import { useContext } from 'react';
import PageContext from '../sub-components/PageContext';
import commentIcon from '../../svgs/comment-icon.svg';
import greenCircleIcon from '../../svgs/green-circle-icon.svg';
import redCircleIcon from '../../svgs/red-circle-icon.svg';
import blueCircleIcon from '../../svgs/blue-circle-icon.svg'; 
import yellowCircleIcon from '../../svgs/yellow-circle-icon.svg'; 
import PageTooltip from './PageTooltip'; 
import displayDateTime from '../functions/displayDateTime';
import ChatIcon from '../../svgs/chat-icon.svg';
import { TableCell } from '@mui/material';

const ProcessingLogTableRow = ({ row, count, tableHeader, stickyEnabled}) =>{
    // get context variables from parent 
    const {
        showProcessingCommentModal, 
        setShowProcessingCommentModal,
        processingRow,
        setProcessingRow, 
    } = useContext(PageContext);

    // event handler to make comment modal visible
    const onViewClick = () =>{
        // show modal with processing comment
        setShowProcessingCommentModal(showProcessingCommentModal => showProcessingCommentModal = true); 
        setProcessingRow(processingRow => processingRow = row); 
    }

    // display red circle for disabled (0) status or green circle for active (1) status
    const statusIcon = (status) =>{
        if ( status == 'Processed'){
            return <img src={greenCircleIcon} className='data-table-icon-left'/>
        }
        else if (status == 'Uploaded' || status == 'Re-Uploaded'){
            return <img src={blueCircleIcon} className='data-table-icon-left' /> 
        }
        else if (status == 'Processing') {
            return <img src={yellowCircleIcon} className='data-table-icon-left' />
        }
        else {
            return <img src={redCircleIcon} className='data-table-icon-left'/>
        }
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return(  
        <>
            {tableHeader.map(el => 
                el['columnname'] == 'status' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>
                        <PageTooltip title={row[el['columnname']]}>
                            {statusIcon(row[el['columnname']])}
                        </PageTooltip>
                    </TableCell>
                : el['columnname'] == 'uploadedtimestamp' || el['columnname'] == 'processedtimestamp' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{displayDateTime(row[el['columnname']])}</TableCell>
                // logic to determine how to display column
                : el['columnname'] == 'blank' ?
                    // display icon for processingcomment column
                    <TableCell className={getRowClassName(el['columnorder'])}>
                        <PageTooltip title='view'>
                            <img src={ChatIcon} className='data-table-icon' onClick={()=>onViewClick()}/> 
                        </PageTooltip>
                    </TableCell>
                // default standard display 
                : row[el['columnname']] ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
                : <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
            )}
        </>
    );
}

export default ProcessingLogTableRow;